import React, {PropTypes} from "react";
import {Card, CardActions, CardHeader, CardMedia, CardTitle, CardText} from "material-ui/Card";
import Carousel from 'react-bootstrap/lib/Carousel';
import CarouselItem from 'react-bootstrap/lib/CarouselItem';
import Dialog from 'material-ui/Dialog';
import LightBox from '../../../components/LightBox';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import Constants from '../../../classes/constants';
const styles = {
  dialogRoot: {
    display: 'flex',
    alignItems: "center",
    justifyContent: "center",
    paddingTop: 0
  },
  dialogContent: {
    position: "relative",
    width: "75vw",
    transform: "",
    maxWidth: 'none'
  },
  dialogBody: {
    paddingBottom: 0
  }
};

function linkify(inputText) {
  var replacedText, replacePattern1, replacePattern2, replacePattern3;

  //URLs starting with http://, https://, or ftp://
  replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
  replacedText = inputText.replace(replacePattern1, ' ..link$1');

  //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
  replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
  replacedText = replacedText.replace(replacePattern2, ' ..linkhttp://$2');

  //Change email addresses to mailto:: links.
  replacePattern3 = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim;
  replacedText = replacedText.replace(replacePattern3, '..link$1');

  replacedText= replacedText.replace(/\n/g, " ..b ");

  return replacedText;
}
class Cards extends React.Component {

  constructor() {
    super();
    this.state = {expanded: false,error: false,open: false};
  }


  render() {


    let description  = linkify(this.props.data.description);
    description = description.split(' ');
    let imgs=[];
    try{
      let images = JSON.parse(this.props.data.imageLink);
         images.map((im)=> {
          // imgs.push({src: "https://hrms.quikrcorp.com/app/assets/picture/"+im.substr(0,im.length-4)})
             imgs.push({src: Constants.defaultProfilePicture[0]})
        });

    }
    catch(error)
    {console.log("do nothing")};


    return (
      <div
        className={this.state.expanded?"col-md-12":"col-md-12"}
        style={{
        }}
      >
        <Card
          className="grow"
          containerStyle={{
            backgroundColor: 'white',
            borderWidth: '1px',
            borderTopStyle: 'solid',
            borderTopColor: '#428BCA'
          }}

          expanded={this.state.expanded} onExpandChange={(expanded) => {
          this.setState({expanded: expanded});
        }}>
          <CardHeader

            title={!this.state.expanded?this.props.data.title:<i style={{opacity: '0.5'}}>&nbsp;{this.props.data.empName} wrote..</i>}
            subtitle={!this.state.expanded?<u>published on {new Date(this.props.data.createdTime).toDateString()}</u>:
              null}
            avatar={"/public/images/profile.png"}
            actAsExpander={true}
            showExpandableButton={true}
          />
          {!this.state.expanded?<CardText
             >
            {this.props.data.description.substr(0,100)+"......"}
          </CardText>:null}
          {!this.state.error ?
          <CardMedia
            expandable={true}>
            <img  width={"100%"} height={"300px"}
                  className="hand"
                  onError={()=> {
                    this.setState({error: true})
                  }}
                  // src={"https://hrms.quikrcorp.com/app/assets/picture/"+this.props.data.imageLink}/>
              src={Constants.defaultProfilePicture[0]}/>
          </CardMedia>:null}
           <CardTitle style={{background: 'rgb(0, 139, 207)'}}
                      titleStyle={{color: 'white'}}
                      subtitleStyle={{color: 'white'}}
                      title={this.props.data.title}
                      subtitle={this.props.data.subTitle} expandable={true}/>
          <CardText
            style={{paddingLeft: '30px'}}
            expandable={true}>

            <div style={{borderLeft: 'solid 1px green'}} className="col-md-12">
              <LightBox

                close={()=>{this.setState({open: false})}}
                images={imgs}
                open={this.state.open}/>
              <Dialog
                contentStyle={ styles.dialogContent }
                bodyStyle={ styles.dialogBody }
                style={ styles.dialogRoot }

                overlayStyle={{background: 'black',opacity: '0.75'}}

                onRequestClose={()=>{
                  this.setState({open: false})
                }}
                open={false} modal={false}>
              <br/></Dialog>
              {imgs.length>0?<img

                className="hand viewMore growLots"
                onClick={()=>{
                  this.setState({open: true})
                }}
                style={{float : 'left',marginRight: '10px',marginBottom: '10px'}}
                src={imgs[0].src} height="150px" width="150px" />:
              null}

            { description.map((index,character)=>{

              if(index.includes("..link"))
              {
                index = index.slice(6,index.length);
                return <a href={index} target="_blank">{index}</a>
              }
              else if(index.includes("..b"))
                return <font><br/><br/></font>;
              else
              return <font  style={{float: 'left'}}>{index}&nbsp;<br/></font>;
            })}
            </div>
            <div style={{ paddingLeft: 0}} className="col-md-12">

            &nbsp;
          <br/>

            <br/>
            <i style={{opacity: '0.5'}}>published on - {this.props.data.createdTime}</i>
              </div>
            &nbsp;

          </CardText>

          <CardActions>
            <RaisedButton primary={true} label={this.state.expanded?"Close":"View Details"} onClick={()=>{
             this.setState({expanded: !this.state.expanded})
            }}/>
            {this.props.data.category=='Quikr_Inspector'? <RaisedButton
              onClick={()=>{
                window.open(this.props.data.feedbackLink);

              }}
              primary={true}label="Give Feedback" />:null}
            {this.props.employee.empno==this.props.data.empId?
              <RaisedButton
                onClick={()=>{this.props.deleteAnnouncement(this.props.data.id)}}
              secondary={true} label="Delete" />:null}

          </CardActions>
        </Card>
        <br/>
      </div>
    );
  }
}

Cards.propTypes = {};

export default Cards;





/** WEBPACK FOOTER **
 ** ./src/feature/announcements/components/Card.js
 **/